export default "__VITE_ASSET__DgJgpX9$__"